import { API_PATH } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import apiConfig from "api/client";
import { PartnersResponse } from "./model/PartnersResponse";

export type PartnersRepository = {
  getPartnerList(params?: {
    page: number;
    limit: number;
  }): Promise<BaseApiResponseModel<PartnersResponse[]>>;
};

class PartnersImpl implements PartnersRepository {
  async getPartnerList(params?: {
    page: number;
    limit: number;
  }): Promise<BaseApiResponseModel<PartnersResponse[]>> {
    return await apiConfig.get(API_PATH.PARTNER_LIST, params);
  }
}

export const defaultPartnersRepository = new PartnersImpl();
